import type { ReactNode } from 'react'
import React from 'react'
import { Flex, csx } from '@vtex/admin-ui'

import { SearchModalMobile } from './components/SearchModalMobile'
import { Page } from '../../ui/components/Page'
import {
  MenuActions,
  SearchErrorBoundary,
  SearchErrorBoundaryProvider,
  SearchFiltersArea,
  SearchResultsArea,
} from './components'
import { ITEMS_PER_PAGE } from './constants'
import { LocalizationContainer } from '../Checkout/components'
import { ChunkLoadErrorBoundary } from '../../core/components'

export type SearchScreenProps = {
  itemsPerPage?: number
  children?: ReactNode
}

export const SearchScreen = ({
  itemsPerPage = ITEMS_PER_PAGE,
}: SearchScreenProps) => {
  return (
    <LocalizationContainer>
      <Page
        className={csx({
          display: 'flex',
          flex: 1,
          '> div': {
            display: 'flex',
            flex: 1,
          },
        })}
      >
        <MenuActions />
        <SearchErrorBoundaryProvider>
          <SearchErrorBoundary>
            <ChunkLoadErrorBoundary>
              <Flex
                className={csx({
                  flex: 1,
                })}
              >
                <SearchFiltersArea />
                <SearchResultsArea itemsPerPage={itemsPerPage} />
              </Flex>
            </ChunkLoadErrorBoundary>
          </SearchErrorBoundary>
        </SearchErrorBoundaryProvider>
        <SearchModalMobile />
      </Page>
    </LocalizationContainer>
  )
}
